import { inject } from 'vue';
import { ChakraStore } from './types';

export const chakraStoreKey = 'chakraStore';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function useChakraStore() {
  return inject(chakraStoreKey) as ChakraStore;
}
